// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__2JXDV","footer":"ModalFilter_footer__2HCD5"};